export * from './to-html';
console.warn('"raeditor/utils/html" module is deprecated, use "raeditor/utils/to-html" instead');
